import { Suspense, useState } from "react";
import { Outlet } from "react-router-dom";
import { Box, Drawer, Typography, useMediaQuery } from "@mui/material";
import SideBar from "./SideBar";
import Header from "./Header";
import { PageLoading } from "./LoadingState";
import PendingIssuesPrompt from "./PendingIssuesPrompt";

const MENU_WIDTH = 248;

// Menu in a side column on wide screens (can be hidden), in a slide-out
// drawer on phones and small tablets.
export default function AppLayout() {
  const wide = useMediaQuery("(min-width:900px)", { noSsr: true });
  const [columnOpen, setColumnOpen] = useState(true);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const menuOpen = wide ? columnOpen : drawerOpen;

  const toggleMenu = () =>
    wide ? setColumnOpen((open) => !open) : setDrawerOpen((open) => !open);

  return (
    <Box sx={{ display: "flex", minHeight: "100vh", bgcolor: "#ffffff", textAlign: "left" }}>
      {wide ? (
        <Box
          sx={{
            width: columnOpen ? MENU_WIDTH : 0,
            flexShrink: 0,
            overflow: "hidden",
            transition: "width 0.25s ease",
            position: "sticky",
            top: 0,
            height: "100vh",
          }}
        >
          <Box sx={{ width: MENU_WIDTH, height: "100%" }}>
            <SideBar />
          </Box>
        </Box>
      ) : (
        <Drawer
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
          ModalProps={{ keepMounted: true }}
          PaperProps={{ sx: { width: MENU_WIDTH, border: "none" } }}
        >
          <SideBar onNavigate={() => setDrawerOpen(false)} />
        </Drawer>
      )}

      <Box sx={{ flex: 1, minWidth: 0, display: "flex", flexDirection: "column" }}>
        <Header onToggleMenu={toggleMenu} menuOpen={menuOpen} />
        <Box
          component="main"
          sx={{
            flex: 1,
            textAlign: "left",
            px: { xs: 1.5, sm: 3, lg: 4 },
            py: { xs: 2, sm: 3 },
          }}
        >
          <Suspense fallback={<PageLoading />}>
            <Outlet />
          </Suspense>
        </Box>
        <Typography
          component="footer"
          sx={{ textAlign: "center", fontSize: 11, color: "#3D4F58", fontStyle: "italic", py: 1 }}
        >
          Powered by Rosoftsavvy © {new Date().getFullYear()}. All rights reserved.
        </Typography>
      </Box>
      <PendingIssuesPrompt />
    </Box>
  );
}
